import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import auth from '../../utils/auth';
import { fetchAccount } from '../../features/account/slice';
import { Container } from '../container';
import { AlertError } from '../alert';
import { Loader } from '../loader';

const notAllowedLabel = {
  en: 'You are not allowed to access this page.',
  id: 'Anda tidak diperbolehkan melihat halaman ini.'
}

const failedToFetchLabel = {
  en: 'Failed to fetch data.',
  id: 'Gagal memuat data.'
}

const retryLabel = {
  en: 'Retry',
  id: 'Coba lagi'
}

const { getTokenFromLocalStorage, getAccountTypeId } = auth()

const Layout = ({children}) => {
  return (
    <Container className="text-center py-8 lg:py-16">
      {children}
    </Container>
  )
}

const PrivateRoute = ({ children, route, ...rest }) => {
  /* codes
  1. no token
  2. have token, no account data
  3. have token, have data, not allowed
  4. have token, have data, allowed
   */
  const [status, setStatus] = React.useState(null)
  const language = useSelector(state => state.system.language)
  const fetchAccountStatus = useSelector(state => state.account.status)
  const error = useSelector(state => state.account.error)
  const account = useSelector(state => state.account.data)
  const dispatch = useDispatch()

  React.useEffect(() => {
    if(getTokenFromLocalStorage()){
      if(getAccountTypeId(account) !== false){
        if(!route.roles){
          setStatus(4)
        } else if(route.roles && route.roles.includes(getAccountTypeId(account))){
          setStatus(4)
        } else {
          setStatus(3)
        }
      }else{
        // have token, but no account data.
        // fetch account
        setStatus(2)
      }
    } else {
      setStatus(1)
    }
  }, [setStatus, account, route])

  React.useEffect(() => {
    if(status === 2){
      dispatch(fetchAccount())
    }
  }, [status, dispatch])

  if(status === null){
    return <Layout>loading...</Layout>
  }
  else if(status === 1){
    return <Redirect to="/login" />
  }
  else if(status === 2){
    return <Layout>
      {
        fetchAccountStatus === 'idle' &&
        <div>Idling.</div>
      }
      {
        fetchAccountStatus === 'failed' &&
        <div>
          <div className="mb-5 lg:mb-10">
            {failedToFetchLabel[language.name]}
            <br/>
            <span className="link cursor-pointer" onClick={() => dispatch(fetchAccount())}>
              {retryLabel[language.name]}
            </span>
          </div>
          {
            error &&
            <AlertError message={error}/>
          }
        </div>
      }
      {
        fetchAccountStatus === 'loading' &&
        <div>
          <Loader />
        </div>
      }
    </Layout>
  }
  else if(status === 3){
    return <Redirect to="/" />
  }
  else if(status === 4){
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /login page
    return (
      <Route {...rest} />
    );
  } else {
    return <Layout>
      {notAllowedLabel[language.name]}
    </Layout>
  }
};

export { PrivateRoute };
